import { render, staticRenderFns } from "./input-boolean.vue?vue&type=template&id=73477bb1&"
import script from "./input-boolean.vue?vue&type=script&lang=js&"
export * from "./input-boolean.vue?vue&type=script&lang=js&"
import style0 from "./input-boolean.vue?vue&type=style&index=0&id=73477bb1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports